<app-navbar></app-navbar>

<router-outlet></router-outlet>

<app-footer></app-footer>
<a class="wa-float" [href]="footer.contact.whatsapp" target="_blank" rel="noopener" aria-label="WhatsApp us">
  <i class="bi bi-whatsapp"></i>
</a>

<app-ai-chat-widget></app-ai-chat-widget>

@if (showInitialLoader) {
<app-loader />
}

<app-cursor></app-cursor>
